<template>
  <div class="container">
    <content-header :data="[{text: '试卷一览', path: '/testPaper/list'},{text: testPaperName+' 试题管理', path: ''}]"></content-header>
    <div class="content">
      <div class="content-bar">
        <div class="search-entry">
          <el-select v-model="type" clearable value-key="id" placeholder="请选择题型" @change="searchHandle">
            <el-option
              v-for="item in typeIds"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="search-entry">
          <el-select v-model="categoryId" clearable value-key="id" placeholder="请选择分类" @change="searchHandle">
            <el-option
              v-for="item in categoryIds"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
      </div>
      <!-- 列表区域 -->
      <div class="content-list">
        <el-table
          :data="tableData"
          border
          stripe
          @selection-change="handleAddSelectionChange"
          >
          <el-table-column
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column
            label="题型"
            fixed>
            <template slot-scope="scope">
            <span>{{scope.row.type===1?'单选题':'多选题'}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="试题摘要"
            width="200"
            >
            <template slot-scope="scope">
              <div>{{scope.row.question}}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="category_name"
            label="试题分类">
          </el-table-column>
          <el-table-column
            prop="created"
            label="创建时间"
            width="180">
          </el-table-column>
          <!--el-table-column
            fixed="right"
            label="操作"
            width="200">
            <template slot-scope="scope">
              <el-button @click="downloadHandle(scope)" type="text" size="small" >查看</el-button>
              <el-button @click="initEditHandle(scope)" type="text" size="small" >修改</el-button>
              <el-button @click="deleteHandle(scope)" type="text" size="small" >删除</el-button>
            </template>
          </el-table-column-->
        </el-table>
        <div class="pagination" v-if="total > pageSize">
          <el-pagination
            @size-change="pageSizeChange"
            @current-change="curPageChange"
            :current-page="curPage"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
        <el-button type="primary" @click="addQuestionHandle()" >添加试题到本试卷</el-button>
      </div>
      <div class="content-bar">
        <div class="search-entry">
          已添加的试题
        </div>
      </div>
      <!-- 列表区域 -->
      <div class="content-list">
        <el-table
          :data="paperQuestionData"
          border
          stripe
          @selection-change="handleRemoveSelectionChange"
          >
          <el-table-column
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column
            label="题型"
            fixed>
            <template slot-scope="scope">
            <span>{{scope.row.type===1?'单选题':'多选题'}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="试题摘要"
            width="200"
            >
            <template slot-scope="scope">
              <div>{{scope.row.question}}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="category_name"
            label="试题分类">
          </el-table-column>
          <el-table-column
            prop="created"
            label="创建时间"
            width="180">
          </el-table-column>
          <!--el-table-column
            fixed="right"
            label="操作"
            width="200">
            <template slot-scope="scope">
              <el-button @click="downloadHandle(scope)" type="text" size="small" >查看</el-button>
              <el-button @click="initEditHandle(scope)" type="text" size="small" >修改</el-button>
              <el-button @click="deleteHandle(scope)" type="text" size="small" >删除</el-button>
            </template>
          </el-table-column-->
        </el-table>
        <div class="pagination" v-if="total2 > pageSize2">
          <el-pagination
            @size-change="pageSizeChange2"
            @current-change="curPageChange2"
            :current-page="curPage2"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pageSize2"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total2">
          </el-pagination>
        </div>
        <el-button type="primary" @click="removeQuestionHandle()" >去除所选试题</el-button>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
  import constants from 'config/constants'
  import QuestionModel from 'models/question'
  import KyEditor from 'components/KyEditor'
  import TestPaperModel from 'models/testPaper'

  export default {
    components: {
      KyEditor,
    },
    data () {
      return {
        domainPic: constants.basic.domain_pic,
        keywords: '',
        tableData: [],
        paperQuestionData: [],
        testPaperId: '',
        testPaperName: '',
        // 要添加的
        addSelection: [],
        // 要删除的
        removeSelection: [],
        curPage: 1,
        pageSize: 10,
        total: 0,
        curPage2: 1,
        pageSize2: 10,
        total2: 0,
        //
        categoryId: '',
        categoryIds: [],
        type: '',
        typeIds: [{id: '1', name: '单选题'}, {id: '2', name: '多选题'}],
      }
    },
    created () {
      this.testPaperId = this.$route.query.id
      this.testPaperName = this.$route.query.name
      QuestionModel.findCategory({curPage: 1, pageSize: 1000}).then(res => {
        this.categoryIds = res.item_list
      })
      this.getObjList()
      this.getObjList2()
    },
    methods: {
      //
      pageSizeChange (size) {
        this.pageSize = size
        this.getObjList()
      },
      curPageChange (page) {
        this.curPage = page
        this.getObjList()
      },
      getObjList (opts) {
        const _opts = {
          curPage: this.curPage,
          pageSize: this.pageSize,
          keywords: this.keywords,
          type: this.type,
          categoryId: this.categoryId,
          testPaperId: this.testPaperId
        }
        // 合并参数
        if (typeof opts === 'object') Object.assign(_opts, opts)
        //
        QuestionModel.findForTestPaper(_opts).then(res => {
          this.tableData = res.item_list
          this.total = res.total
        })
      },
      //
      pageSizeChange2 (size) {
        this.pageSize2 = size
        this.getObjList2()
      },
      curPageChange2 (page) {
        this.curPage2 = page
        this.getObjList2()
      },
      getObjList2 (opts) {
        const _opts = {
          curPage: this.curPage2,
          pageSize: this.pageSize2,
          id: this.testPaperId
        }
        // 合并参数
        if (typeof opts === 'object') Object.assign(_opts, opts)
        //
        TestPaperModel.findQuestion(_opts).then(res => {
          this.paperQuestionData = res.item_list
          this.total2 = res.total
        })
      },
      //
      deleteHandle (item) {
        this.$confirm('是否确认删除？')
          .then(_ => {
            QuestionModel.delete({
              id: item.row.id,
            }).then(() => {
              this.tableData.splice(item.$index, 1)
              this.$message({ message: '删除成功', type: 'success' })
            }).catch(err => {
              this.$message({ message: err.message, type: 'error' })
            })
          })
          .catch(_ => {})
      },
      confirmHandle () {
        this.$refs.curObjForm.validate(valid => {
          if (!valid) return
          if (this.curObj.id) return this.editHandle()
          this.newHandle()
        })
      },
      initNewHandle () {
        this.curObj = {
          id: '',
          name: '',
          image: ''
        }
        this.isObjShow = true
      },
      newHandle () {
        QuestionModel.create({
          name: this.curObj.name,
          image: this.curObj.image,
        }).then(() => {
          this.getObjList()
          this.isObjShow = false
          this.$message({ message: '添加成功', type: 'success' })
        }).catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
      },
      initEditHandle (item) {
        this.$router.push({
          name: 'question.new',
          query: { id: item.row.id }
        })
      },
      editHandle () {
        QuestionModel.update({
          id: this.curObj.id,
          name: this.curObj.name,
          image: this.curObj.image,
        }).then(() => {
          this.getObjList()
          this.isObjShow = false
          this.$message({ message: '更新成功', type: 'success' })
        }).catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
      },
      searchHandle () {
        this.getObjList()
      },
      downloadHandle (item) {
        this.$router.push({
          name: 'question.qrcode',
          query: {redEnvelopeId: item.row.id, type: 2}
        })
      },
      dateChange (value) {
        if (value) {
          this.startDate = value[0]
          this.endDate = value[1]
        } else {
          this.startDate = ''
          this.endDate = ''
        }
      },
      handleAddSelectionChange (val) {
        this.addSelection = val
      },
      addQuestionHandle () {
        let questionId = []
        this.addSelection.forEach(function (item) {
          questionId.push(item.id)
        })
        TestPaperModel.addQuestion({
          id: this.testPaperId,
          questionId: questionId.join(',')
        }).then(() => {
          this.getObjList()
          this.getObjList2()
          this.isObjShow = false
          this.$message({ message: '添加成功', type: 'success' })
        }).catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
      },
      handleRemoveSelectionChange (val) {
        this.removeSelection = val
      },
      removeQuestionHandle () {
        let questionId = []
        this.removeSelection.forEach(function (item) {
          questionId.push(item.id)
        })
        TestPaperModel.removeQuestion({
          id: this.testPaperId,
          questionId: questionId.join(',')
        }).then(() => {
          this.getObjList()
          this.getObjList2()
          this.isObjShow = false
          this.$message({ message: '添加成功', type: 'success' })
        }).catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.container
  min-height: 100%
  background-color: #fff
  .content
    .content-bar
      padding: 20px
      .search-entry
        display: inline-block
        vertical-align: top
        margin-right: 10px
        margin-bottom: 10px
      .search-btn
        display: inline-block
        vertical-align: top
    .content-list
      padding-left: 20px
      padding-right: 20px
      padding-bottom: 40px
      .pagination
        margin-top: 10px
    .new-wrap
      .el-input
        width: 300px
      .form-title
        padding-top: 10px
        padding-bottom: 10px
        font-size: 12px
        color: #aaa
      .check-title
        text-align: right
        display: inline-block
        vertical-align: middle
        width: 90px
        font-size: 14px
        color: #48576a
        line-height: 1
        padding: 11px 12px 11px 0
        box-sizing: border-box
      .avatar-uploader
          border: 1px dashed #d9d9d9
          border-radius: 6px
          cursor: pointer
          position: relative
          overflow: hidden
          width: 180px
          &:hover
            border-color: #409EFF
          .avatar-uploader-icon
            font-size: 28px
            color: #8c939d
            width: 178px
            height: 178px
            line-height: 178px
            text-align: center
          .avatar
            width: 178px
            height: 178px
            display: block
</style>



// WEBPACK FOOTER //
// src/views/TestPaperQuestion.vue